import React, { createContext, useContext, useState } from "react";
import api from "../api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("rs_admin_token"));
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("rs_admin_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  const login = async ({ username, password }) => {
    const response = await api.post("/api/admin/login", { username, password });
    const nextToken = response?.data?.token;
    const nextUser = response?.data?.user;

    if (!nextToken) {
      throw new Error("Login failed: missing token");
    }

    localStorage.setItem("rs_admin_token", nextToken);
    localStorage.setItem("rs_admin_user", JSON.stringify(nextUser || null));
    setToken(nextToken);
    setUser(nextUser || null);
    return { token: nextToken, user: nextUser };
  };

  const bootstrap = async ({ username, password }) => {
    await api.post("/api/admin/bootstrap", { username, password });
    return login({ username, password });
  };

  const logout = () => {
    localStorage.removeItem("rs_admin_token");
    localStorage.removeItem("rs_admin_user");
    setToken(null);
    setUser(null);
  };

  const value = { token, user, isAuthenticated: !!token, login, bootstrap, logout };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
